import { TUTORIALS, TUTORIAL_GROUPS } from './tutorial-content.js';

const transient = new Set(['battle','card-detail','universe','notifications','player-profile']);
const normalize = text => text.toLocaleLowerCase('ru').replaceAll('ё','е');

export function renderLearningCenter({root, states, here, start, complete, reopen}) {
  const doc=root.ownerDocument;
  function el(tag,parent,text,className='') {
    const node=doc.createElement(tag);node.className=className;
    if(text!==undefined) node.textContent=text;
    parent.append(node);return node;
  }
  function button(parent,text,action,className='') {
    const node=el('button',parent,text,className);node.type='button';node.onclick=action;return node;
  }
  root.replaceChildren();
  const head=el('header',root,undefined,'learning-head');
  el('h1',head,'Как играть в REVERSE');
  el('p',head,'От первой карты до клановой войны. Выбери тему и следуй коротким шагам.');
  el('p',head,`Изучено ${states.filter(s=>s.status==='complete').length} из ${TUTORIALS.length} тем`,'learning-progress');
  const unfinished=TUTORIALS.find((g,i)=>['paused','started'].includes(states[i].status));
  const recommended=unfinished || TUTORIALS.find(g=>g.id===here) || TUTORIALS[0];
  button(head,`${unfinished?'Продолжить':'Начать с темы'}: ${recommended.title}`,()=>article(recommended),'learning-resume');
  const label=el('label',root,'Найти инструкцию','learning-search-label');label.htmlFor='learning-search';
  const search=el('input',root);search.id='learning-search';search.type='search';search.placeholder='Например: колода, крутки, вклад';
  const filters=el('div',root,undefined,'learning-filters');filters.setAttribute('role','group');filters.setAttribute('aria-label','Темы обучения');
  const results=el('p',root,'','learning-results');results.setAttribute('role','status');
  const list=el('div',root,undefined,'tutorial-list');
  const empty=el('p',root,'Ничего не найдено. Попробуй другое слово или выбери «Все темы».','learning-empty');empty.hidden=true;
  let selected='Все темы';
  const filtersButtons=['Все темы',...TUTORIAL_GROUPS].map(group=>button(filters,group,()=>{selected=group;render();}));
  function render() {
    list.replaceChildren();let count=0;
    filtersButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.textContent===selected)));
    const query=normalize(search.value.trim());
    for(const group of TUTORIAL_GROUPS) {
      const matches=TUTORIALS.filter(g=>g.group===group&&(selected==='Все темы'||g.group===selected)&&normalize([g.title,g.group,...g.steps.map(s=>s.title+' '+s.text)].join(' ')).includes(query));
      if(!matches.length) continue;
      const section=el('section',list);el('h2',section,group);
      for(const g of matches) {
        const state=states[TUTORIALS.indexOf(g)];
        const row=button(section,'',()=>article(g),'learning-topic');
        el('strong',row,g.title);
        el('span',row,g.steps[0].title,'learning-description');
        el('small',row,`${g.steps.length} ${g.steps.length===1?'шаг':g.steps.length<5?'шага':'шагов'} · ${state.status==='complete'?'Изучено':['paused','started'].includes(state.status)?'Можно продолжить':'Читать инструкцию'}`);
        count++;
      }
    }
    empty.hidden=count>0;results.textContent=`Найдено тем: ${count}`;
  }
  function article(g) {
    root.replaceChildren();
    button(root,'Все темы',()=>reopen(),'learning-back');
    const header=el('header',root,undefined,'learning-head');
    const title=el('h1',header,g.title);title.tabIndex=-1;
    el('p',header,'Следуй шагам по порядку. К инструкции можно вернуться в любое время.');
    const steps=el('ol',root,undefined,'learning-steps');
    for(const item of g.steps) {const li=el('li',steps);el('h2',li,item.title);el('p',li,item.text);}
    const actions=el('div',root,undefined,'learning-article-actions');
    if(!transient.has(g.id)) button(actions,'Показать в игре',()=>start(g.id),'learning-primary');
    else el('p',actions,'Для подсветки элементов открой этот экран в игре и нажми «?». Эту инструкцию можно читать заранее.');
    button(actions,'Отметить как изученное',()=>complete(g),'learning-secondary');
    title.focus({preventScroll:true});root.scrollIntoView({block:'start',behavior:'instant'});
  }
  search.oninput=render;render();
}
